import config from "config/config";
import { useTranslation } from "react-i18next";

const GenericError = (props) => {
  const { t } = useTranslation();
  const { error } = props;

  const showErrorMessage = config.ENV === "DEV" || config.ENV === "QA";

  return (
    <div className="break-words max-w-[600px]">
      <h1 className="flex justify-start font-brand text-theme-primary text-4xl">
        {t("CustomerGenericError-title")}
      </h1>
      <hr />
      <h2 className="text-xl font-body text-theme-text-secondary">
        {t("CustomerGenericError-desc")}
        {showErrorMessage && (
          <div>
            <div className="text-base mt-6">
              {t("CustomerGenericError-error-message")} {error.message}
            </div>
            <div className="break-all text-base mt-6 break-words">
              {t("CustomerGenericError-stack-trace")} {error.stack}
            </div>
          </div>
        )}
      </h2>
    </div>
  );
};

export default GenericError;
